import React, { useState, useEffect } from 'react'
import ReactDOM from 'react-dom'

import AppClass from './../../../../../../../js/classes/App'

import './css/styles.scss'

const YoutubeShowApp = () => {
    const [youtubeLink, setYoutubeLink] = useState(null),
    handleClose = () => {
        setYoutubeLink(false)
    }

    useEffect(() => {
        AppClass.addCallback('show_youtube_link', (_youtubeLink=null) => {
            setYoutubeLink(typeof _youtubeLink === 'string' ? _youtubeLink : null)
        })
    }, [])

    return youtubeLink ? <div className={ `happy-youtube-show` }>
        <div className="happy-youtube-show__blackmask" onClick={ handleClose }></div>
        
        <div className="happy-youtube-show__inner">
            <div className="happy-youtube-show__video">
                <span className="happy-youtube-show__close" onClick={ handleClose }></span>
                <span className="happy-youtube-show__code">
                    <iframe
                        className="happy-youtube-show__iframe"
                        width="560"
                        height="315"
                        src="https://www.youtube.com/embed/TQ_g3ygE21Y/?autoplay=1"
                        title="YouTube video player"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen=""
                    />
                </span>
            </div>
        </div>
    </div> : null
}

const container = document.getElementById('root-youtube-show')

if (container) ReactDOM.render(<YoutubeShowApp />, container)